// extracted by mini-css-extract-plugin
export default {"container":"platform_container__7MSs4","disabledItem":"platform_disabledItem__G8E8i"};